/**
 *
 * 1.2016-12-28  rlair_快速查询
 * 2.2017-3-3 rlair_修复加载更多404bug
 * 3.2017-4-5 rlair_默认进入导航页面
 * 4.2017-05-04  rlair_默认进入town-square
 * 5.2017-05-31  rlair_修复搜索消息并跳转，再次刷新页面无法获取该消息之前和之后的内容的问题
 * 6.2017-06-01  rlair_修复移动端切换频道，显示公告侧栏出现闪退问题
 * 7.2017-07-31  rlair_修复跳转消息后删除该消息一直处于加载状态的问题 by lanbo
 * 8.2017-08-04  rlair_修复注销之后没有退出单点的问题 by lanbo
 * 9.2017-08-11  rlair_手机客户端增加注销后再登录显示splash
 * 10.2017-08-22 rlair_增加oa跳转所需jwt的token
 * 11.2018-06-25 rlair_修复从根路径进入默认频道，发送请求参数不对跳转不对的问题
 * 12.2018-07-11 rlair_修复注销之后登录其他用户但依然是之前用户的问题
 * 13.2018-07-12 rlair_修复未登录时当路由参数有错误时跳转到退出单点地址的问题
 * 14.2018-07-13 rlair_添加关闭浏览器标签页后，再次打开，跳转到上一次的频道的功能
 *
 */
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import debounce from 'lodash/debounce';

import {
    getChannel,
    createDirectChannel,
    getChannelByNameAndTeamName,
    getChannelAndMyMember,
    getChannelStats,
    getMyChannelMember,
    joinChannel,
    markChannelAsRead,
    selectChannel,
} from 'mattermost-redux/actions/channels';
import {getPostThread} from 'mattermost-redux/actions/posts';
import {removeUserFromTeam} from 'mattermost-redux/actions/teams';
import {Client4} from 'mattermost-redux/client';
import {getConfig} from 'mattermost-redux/selectors/entities/general';
import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';
import {getCurrentChannelStats} from 'mattermost-redux/selectors/entities/channels';

import {browserHistory} from 'utils/browser_history';
import {loadChannelsForCurrentUser} from 'actions/channel_actions.jsx';
import {handleNewPost} from 'actions/post_actions.jsx';
import {stopPeriodicStatusUpdates} from 'actions/status_actions.jsx';
import {loadNewDMIfNeeded, loadNewGMIfNeeded, loadProfilesForSidebar} from 'actions/user_actions.jsx';
import {closeRightHandSide, closeMenu as closeRhsMenu} from 'actions/views/rhs';
import {close as closeLhs} from 'actions/views/lhs';
import * as WebsocketActions from 'actions/websocket_actions.jsx';
import AppDispatcher from 'dispatcher/app_dispatcher.jsx';
import BrowserStore from 'stores/browser_store.jsx';
import ChannelStore from 'stores/channel_store.jsx';
import ErrorStore from 'stores/error_store.jsx';
import store from 'stores/redux_store.jsx';
import TeamStore from 'stores/team_store.jsx';
import UserStore from 'stores/user_store.jsx';
import WebSocketClient from 'client/web_websocket_client.jsx';

import {ActionTypes, Constants, ErrorPageTypes, PostTypes} from 'utils/constants.jsx';
import EventTypes from 'utils/event_types.jsx';
import {filterAndSortTeamsByDisplayName} from 'utils/team_utils.jsx';
import * as Utils from 'utils/utils.jsx';
import en from 'i18n/en.json';
import * as I18n from 'i18n/i18n.jsx';
import {equalServerVersions} from 'utils/server_version';

import SearchStore from 'stores/search_store.jsx';

import {trackEvent} from 'actions/diagnostics_actions.jsx';

import * as UserAgent from 'utils/user_agent.jsx';

// 引入getUser，以获取私信的频道name
import {getUser} from 'mattermost-redux/selectors/entities/users';

// 让myTeams使用默认排序，以防止浏览器不支持的情况导致进入不到团队路由
// import {sortTeamsByDisplayName} from 'utils/team_utils.jsx';

const dispatch = store.dispatch;
const getState = store.getState;

export function emitChannelClickEvent(channel) {
    async function userVisitedFakeChannel(chan, success, fail) {
        const currentUserId = UserStore.getCurrentId();
        const otherUserId = Utils.getUserIdFromChannelName(chan);
        const {data: receivedChannel} = await createDirectChannel(currentUserId, otherUserId)(dispatch, getState);
        if (receivedChannel) {
            success(receivedChannel);
        } else {
            fail();
        }
    }
    function switchToChannel(chan) {
        const getMyChannelMemberPromise = getMyChannelMember(chan.id)(dispatch, getState);
        const oldChannelId = ChannelStore.getCurrentId();

        getMyChannelMemberPromise.then(() => {
            getChannelStats(chan.id)(dispatch, getState);

            // Mark previous and next channel as read
            dispatch(markChannelAsRead(chan.id, oldChannelId));
            reloadIfServerVersionChanged();
        });

        // 将最近一次访问的频道放入LAST_VISIT_CHANNEL_STORAGE中，如果是私聊则还需要使用getUser获取频道name
        if (chan.type === Constants.DM_CHANNEL) {
            const teammate = getUser(getState(), channel.teammate_id);
            if (teammate && teammate.username) {
                BrowserStore.setGlobalItem(Constants.LAST_VISIT_CHANNEL_STORAGE, {name: teammate.username, type: chan.type});
            }
        } else {
            BrowserStore.setGlobalItem(Constants.LAST_VISIT_CHANNEL_STORAGE, {name: chan.name, type: chan.type});
        }

        BrowserStore.setGlobalItem(Constants.PREV_CHANNEL_KEY + chan.team_id, chan.name);

        loadProfilesForSidebar();

        AppDispatcher.handleViewAction({
            type: ActionTypes.CLICK_CHANNEL,
            id: chan.id,
            team_id: chan.team_id,
        });
    }

    if (channel.fake) {
        userVisitedFakeChannel(
            channel,
            (data) => {
                switchToChannel(data);
            },
            () => {
                browserHistory.push('/' + this.state.currentTeam.name);
            }
        );
    } else {
        switchToChannel(channel);
    }
}

export async function doFocusPost(channelId, postId, data) {
    // 返回一个Promise，并将除AppDispatcher派发的操作放入下一个事件循环中 by lanbo 2017-07-31
    return new Promise((resolve) => {
        AppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVED_FOCUSED_POST,
            postId,
            channelId,
            post_list: data,
        });

        // 将操作放入下一个事件循环中 by lanbo 2017-07-31
        setTimeout(async () => {
            dispatch({
                type: ActionTypes.RECEIVED_FOCUSED_POST,
                data: postId,
                channelId,
            });

            const member = getState().entities.channels.myMembers[channelId];
            if (member == null) {
                await joinChannel(UserStore.getCurrentId(), null, channelId)(dispatch, getState);
            }

            loadChannelsForCurrentUser();
            getChannelStats(channelId)(dispatch, getState);

            // 操作完成后结束 by lanbo 2017-07-31
            resolve();
        }, 0);
    });

    // 将获取前后消息的方法放到下一个事件循环中，以便能正确获取到channelId
}

export function emitCloseRightHandSide() {
    dispatch(closeRightHandSide());
}

export async function emitPostFocusEvent(postId, returnTo = '') {
    loadChannelsForCurrentUser();
    const {data} = await dispatch(getPostThread(postId));

    if (!data) {
        browserHistory.push(`/error?type=${ErrorPageTypes.PERMALINK_NOT_FOUND}&returnTo=${returnTo}`);
        return;
    }

    const channelId = data.posts[data.order[0]].channel_id;
    let channel = getState().entities.channels.channels[channelId];
    const teamId = getCurrentTeamId(getState());
    if (!channel) {
        const {data: channelData} = await dispatch(getChannel(channelId));
        if (!channelData) {
            browserHistory.push(`/error?type=${ErrorPageTypes.PERMALINK_NOT_FOUND}&returnTo=${returnTo}`);
            return;
        }
        channel = channelData;
    }
    if (channel.team_id && channel.team_id !== teamId) {
        browserHistory.push(`/error?type=${ErrorPageTypes.PERMALINK_NOT_FOUND}&returnTo=${returnTo}`);
        return;
    }
    if (channel && channel.type === Constants.DM_CHANNEL) {
        loadNewDMIfNeeded(channel.id);
    } else if (channel && channel.type === Constants.GM_CHANNEL) {
        loadNewGMIfNeeded(channel.id);
    }
    await doFocusPost(channelId, postId, data);
}

export function emitPostFocusRightHandSideFromSearch(post, isMentionSearch) {
    getPostThread(post.id)(dispatch, getState).then(
        () => {
            AppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVED_POST_SELECTED,
                postId: Utils.getRootId(post),
                from_search: SearchStore.getSearchTerm(),
                from_flagged_posts: SearchStore.getIsFlaggedPosts(),
                from_pinned_posts: SearchStore.getIsPinnedPosts(),
            });

            AppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVED_SEARCH,
                results: null,
                is_mention_search: isMentionSearch,
            });
        }
    );
}

export function emitLeaveTeam() {
    removeUserFromTeam(TeamStore.getCurrentId(), UserStore.getCurrentId())(dispatch, getState);
}

export function emitUserPostedEvent(post) {
    AppDispatcher.handleServerAction({
        type: ActionTypes.CREATE_POST,
        post,
    });
}

export function emitUserCommentedEvent(post) {
    AppDispatcher.handleServerAction({
        type: ActionTypes.CREATE_COMMENT,
        post,
    });
}

export function showAccountSettingsModal() {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_ACCOUNT_SETTINGS_MODAL,
        value: true,
    });
}

export function toggleShortcutsModal() {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_SHORTCUTS_MODAL,
        value: true,
    });
}

export function showDeletePostModal(post, commentCount = 0) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_DELETE_POST_MODAL,
        value: true,
        post,
        commentCount,
    });
}

export function showChannelHeaderUpdateModal(channel) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_HEADER_UPDATE_MODAL,
        value: true,
        channel,
    });
}

export function showChannelPurposeUpdateModal(channel) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_PURPOSE_UPDATE_MODAL,
        value: true,
        channel,
    });
}

export function showChannelNameUpdateModal(channel) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_CHANNEL_NAME_UPDATE_MODAL,
        value: true,
        channel,
    });
}

export function showGetPostLinkModal(post) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_GET_POST_LINK_MODAL,
        value: true,
        post,
    });
}

export function showGetPublicLinkModal(fileId) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_GET_PUBLIC_LINK_MODAL,
        value: true,
        fileId,
    });
}

export function showGetTeamInviteLinkModal() {
    AppDispatcher.handleViewAction({
        type: Constants.ActionTypes.TOGGLE_GET_TEAM_INVITE_LINK_MODAL,
        value: true,
    });
}

export function showInviteMemberModal() {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_INVITE_MEMBER_MODAL,
        value: true,
    });
}

export function showLeaveTeamModal() {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_LEAVE_TEAM_MODAL,
        value: true,
    });
}

export function showLeavePrivateChannelModal(channel) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.TOGGLE_LEAVE_PRIVATE_CHANNEL_MODAL,
        value: channel,
    });
}

export function emitSuggestionPretextChanged(suggestionId, pretext) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.SUGGESTION_PRETEXT_CHANGED,
        id: suggestionId,
        pretext,
    });
}

export function emitSelectNextSuggestion(suggestionId) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.SUGGESTION_SELECT_NEXT,
        id: suggestionId,
    });
}

export function emitSelectPreviousSuggestion(suggestionId) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.SUGGESTION_SELECT_PREVIOUS,
        id: suggestionId,
    });
}

//快速查询_选中当前项
export function emitSelectSuggestion(suggestionId) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.SUGGESTION_SELECT,
        id: suggestionId,
    });
}

export function emitCompleteWordSuggestion(suggestionId, term = '') {
    AppDispatcher.handleViewAction({
        type: Constants.ActionTypes.SUGGESTION_COMPLETE_WORD,
        id: suggestionId,
        term,
    });
}

export function emitClearSuggestions(suggestionId) {
    AppDispatcher.handleViewAction({
        type: Constants.ActionTypes.SUGGESTION_CLEAR_SUGGESTIONS,
        id: suggestionId,
    });
}

export function emitPreferenceChangedEvent(preference) {
    AppDispatcher.handleServerAction({
        type: Constants.ActionTypes.RECEIVED_PREFERENCE,
        preference,
    });

    if (addedNewDmUser(preference)) {
        loadProfilesForSidebar();
    }
}

export function emitPreferencesChangedEvent(preferences) {
    AppDispatcher.handleServerAction({
        type: Constants.ActionTypes.RECEIVED_PREFERENCES,
        preferences,
    });

    if (preferences.findIndex(addedNewDmUser) !== -1) {
        loadProfilesForSidebar();
    }
}

function addedNewDmUser(preference) {
    return preference.category === Constants.Preferences.CATEGORY_DIRECT_CHANNEL_SHOW && preference.value === 'true';
}

export function emitPreferencesDeletedEvent(preferences) {
    AppDispatcher.handleServerAction({
        type: Constants.ActionTypes.DELETED_PREFERENCES,
        preferences,
    });
}

export function sendEphemeralPost(message, channelId, parentId) {
    const timestamp = Utils.getTimestamp();
    const post = {
        id: Utils.generateId(),
        user_id: '0',
        channel_id: channelId || ChannelStore.getCurrentId(),
        message,
        type: PostTypes.EPHEMERAL,
        create_at: timestamp,
        update_at: timestamp,
        root_id: parentId,
        parent_id: parentId,
        props: {},
    };

    handleNewPost(post);
}

export function sendAddToChannelEphemeralPost(user, addedUsername, addedUserId, channelId, postRootId = '', timestamp) {
    const post = {
        id: Utils.generateId(),
        user_id: user.id,
        channel_id: channelId || ChannelStore.getCurrentId(),
        message: '',
        type: PostTypes.EPHEMERAL_ADD_TO_CHANNEL,
        create_at: timestamp,
        update_at: timestamp,
        root_id: postRootId,
        parent_id: postRootId,
        props: {
            username: user.username,
            addedUsername,
            addedUserId,
        },
    };

    handleNewPost(post);
}

export function newLocalizationSelected(locale) {
    const localeInfo = I18n.getLanguageInfo(locale);

    if (locale === 'en' || !localeInfo) {
        AppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVED_LOCALE,
            locale,
            translations: en,
        });
    } else {
        Client4.getTranslations(localeInfo.url).then(
            (data, res) => {
                let translations = data;
                if (!data && res.text) {
                    translations = JSON.parse(res.text);
                }
                AppDispatcher.handleServerAction({
                    type: ActionTypes.RECEIVED_LOCALE,
                    locale,
                    translations,
                });
            }
        ).catch(
            () => {} //eslint-disable-line no-empty-function
        );
    }
}

export function loadCurrentLocale() {
    const user = UserStore.getCurrentUser();

    if (user && user.locale) {
        newLocalizationSelected(user.locale);
    } else {
        loadDefaultLocale();
    }
}

export function loadDefaultLocale() {
    const config = getConfig(getState());
    let locale = config.DefaultClientLocale;

    if (!I18n.getLanguageInfo(locale)) {
        locale = 'en';
    }

    return newLocalizationSelected(locale);
}

let lastTimeTypingSent = 0;
export function emitLocalUserTypingEvent(channelId, parentPostId) {
    const userTyping = async (actionDispatch, actionGetState) => {
        const state = actionGetState();
        const config = getConfig(state);
        const t = Date.now();
        const stats = getCurrentChannelStats(state);
        const membersInChannel = stats ? stats.member_count : 0;

        if (((t - lastTimeTypingSent) > config.TimeBetweenUserTypingUpdatesMilliseconds) &&
            (membersInChannel < config.MaxNotificationsPerChannel) && (config.EnableUserTypingMessages === 'true')) {
            WebSocketClient.userTyping(channelId, parentPostId);
            lastTimeTypingSent = t;
        }

        return {data: true};
    };

    return dispatch(userTyping);
}

export function emitRemoteUserTypingEvent(channelId, userId, postParentId) {
    AppDispatcher.handleViewAction({
        type: Constants.ActionTypes.USER_TYPING,
        channelId,
        userId,
        postParentId,
    });
}

export function emitUserLoggedOutEvent(redirectTo = '/', shouldSignalLogout = true) {
    Client4.logout().then(
        () => {
            if (shouldSignalLogout) {
                BrowserStore.signalLogout();
            }

            // rlair_修复注销之后没有退出单点的问题
            const config = getConfig(getState());

            // 判断redirectTo，当是直接退出单点时才跳转到退出单点路径
            if (config.EnableRLairlinesSSO && redirectTo === '/') {
                // 手机客户端增加注销后再登录显示splash
                sessionStorage.setItem('__comeback_from_cas__', JSON.stringify(true));
                window.__temp_redirect__ = true; // eslint-disable-line no-underscore-dangle
                // rlair_修复注销之后没有退出单点的问题
                clientLogout(config.RLCasLogoutUrl);
            } else {
                clientLogout(redirectTo);
            }
        }
    ).catch(
        () => {
            const config = getConfig(getState());

            // 修复注销之后没有退出单点的问题
            if (config.EnableRLairlinesSSO) {
                // 手机客户端增加注销后再登录显示splash
                sessionStorage.setItem('__comeback_from_cas__', JSON.stringify(true));
                window.__temp_redirect__ = true; // eslint-disable-line no-underscore-dangle
                window.location.href = config.RLCasLogoutUrl;
            } else {
                browserHistory.push(redirectTo);
            }
        }
    );
}

// 添加跳转方式
export function clientLogout(redirectTo = '/') {
    BrowserStore.clear({exclude: [Constants.RECENT_EMOJI_KEY, '__landingPageSeen__', 'selected_teams']});
    ErrorStore.clearLastError();
    ChannelStore.clear();
    stopPeriodicStatusUpdates();
    WebsocketActions.close();
    document.cookie = 'MMUSERID=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'casAUTHTOKEN=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    // browserHistory.push(redirectTo);

    // 注销之后通知客户端清除未读数
    if (UserAgent.isDesktopApp() && window.dapp && window.dapp.clearUnread) {
        window.dapp.clearUnread();
    }

    // 路由跳转
    window.location.href = redirectTo;
}

export function emitSearchMentionsEvent(user) {
    let terms = '';
    if (user.notify_props) {
        const termKeys = UserStore.getMentionKeys(user.id);

        if (termKeys.indexOf('@channel') !== -1) {
            termKeys[termKeys.indexOf('@channel')] = '';
        }

        if (termKeys.indexOf('@all') !== -1) {
            termKeys[termKeys.indexOf('@all')] = '';
        }

        terms = termKeys.join(' ');
    }

    trackEvent('api', 'api_posts_search_mention');

    AppDispatcher.handleServerAction({
        type: ActionTypes.RECEIVED_SEARCH_TERM,
        term: terms,
        do_search: true,
        is_mention_search: true,
    });
}

export function toggleSideBarAction(visible) {
    if (!visible) {
        //Array of actions resolving in the closing of the sidebar
        AppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVED_SEARCH,
            results: null,
        });

        AppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVED_SEARCH_TERM,
            term: null,
            do_search: false,
            is_mention_search: false,
        });

        AppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVED_POST_SELECTED,
            postId: null,
        });
    }
}

export function toggleSideBarRightMenuAction() {
    dispatch(closeRightHandSide());
    dispatch(closeLhs());
    dispatch(closeRhsMenu());
}

export function emitBrowserFocus(focus) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.BROWSER_CHANGE_FOCUS,
        focus,
    });
}

export async function redirectUserToDefaultTeam() {
    const teams = TeamStore.getAll();
    const teamMembers = TeamStore.getMyTeamMembers();
    let teamId = BrowserStore.getGlobalItem('team');

    // 添加channelType参数用于判断频道类型
    function redirect(teamName, channelName, channelType = Constants.OPEN_CHANNEL) {
        // 根据饲料、群组、频道进行不同的url拼接跳转
        if (channelType === Constants.DM_CHANNEL) {
            browserHistory.push(`/${teamName}/messages/@${channelName}`);
        } else if (channelType === Constants.GM_CHANNEL) {
            browserHistory.push(`/${teamName}/messages/${channelName}`);
        } else {
            browserHistory.push(`/${teamName}/channels/${channelName}`);
        }
    }

    if (!teams[teamId] && teamMembers.length > 0) {
        let myTeams = [];
        for (const index in teamMembers) {
            if (teamMembers.hasOwnProperty(index)) {
                const teamMember = teamMembers[index];
                myTeams.push(teams[teamMember.team_id]);
            }
        }

        if (myTeams.length > 0) {
            myTeams = filterAndSortTeamsByDisplayName(myTeams);
            if (myTeams && myTeams[0]) {
                teamId = myTeams[0].id;
            }
        }
    }

    const team = teams[teamId];
    if (team) {
        const channelId = BrowserStore.getGlobalItem(teamId);
        const channel = ChannelStore.getChannelById(channelId);
        let channelName = Constants.DEFAULT_CHANNEL;

        // 获取上一次存储的频道信息
        const lastVisitChannel = BrowserStore.getGlobalItem(Constants.LAST_VISIT_CHANNEL_STORAGE);
        let channelType = Constants.OPEN_CHANNEL;

        // 如果有上一次存储的信息则使用该信息进行跳转
        if (lastVisitChannel && lastVisitChannel.name && lastVisitChannel.type) {
            channelType = lastVisitChannel.type;
            channelName = lastVisitChannel.name;
        } else if (channel && channel.team_id === team.id) {
            dispatch(selectChannel(channel.id));
            channelName = channel.name;
        } else if (channelId) {
            const {data} = await getChannelAndMyMember(channelId)(dispatch, getState);
            if (data) {
                dispatch(selectChannel(channelId));
                channelName = data.channel.name;
            }
        } else {
            const {data} = await dispatch(getChannelByNameAndTeamName(team.name, channelName));
            if (data) {
                dispatch(selectChannel(data.id));
            }
        }

        // 添加了channelType对频道类型进行判断，以便能正确拼接跳转的url
        redirect(team.name, channelName, channelType);
    } else {
        browserHistory.push('/select_team');
    }
}

export const postListScrollChange = debounce(() => {
    AppDispatcher.handleViewAction({
        type: EventTypes.POST_LIST_SCROLL_CHANGE,
        value: false,
    });
});

export function postListScrollChangeToBottom() {
    AppDispatcher.handleViewAction({
        type: EventTypes.POST_LIST_SCROLL_CHANGE,
        value: true,
    });
}

export function emitPopoverMentionKeyClick(isRHS, mentionKey) {
    AppDispatcher.handleViewAction({
        type: ActionTypes.POPOVER_MENTION_KEY_CLICK,
        isRHS,
        mentionKey,
    });
}

let serverVersion = '';

export function reloadIfServerVersionChanged() {
    const newServerVersion = Client4.getServerVersion();

    if (serverVersion && !equalServerVersions(serverVersion, newServerVersion)) {
        console.log(`Detected version update from ${serverVersion} to ${newServerVersion}; refreshing the page`); //eslint-disable-line no-console
        window.location.reload(true);
    }

    serverVersion = newServerVersion;
}

//rlair_获取jwt跳转的token
export async function getJwtToken(url, success) {
    await Client4.getJwtToken().then(
        (data) => {
            if (data && data.hasOwnProperty('token')) {
                success(url, data.token);
            }
        }
    ).catch(
        () => {} //eslint-disable-line no-empty-function
    );
}
